import { Component, HostListener } from '@angular/core';
import { HelpNavigationService } from '../services/help-navigation.service';


@Component({
  selector: 'app-help-licence',
  imports: [],
  templateUrl: './help-licence.component.html',
  styleUrl: './help-licence.component.scss'
})
export default class HelpLicenceComponent {
  constructor(
    private navigationService: HelpNavigationService) { }
  selectedSection = 'licence';

  ngOnInit(): void {

    this.navigationService.selectedSection.next('licence');

    this.navigationService.selectedSection.subscribe(section => {
      this.selectedSection = section;
    });

  }

  changeSection(section: string): void {

    this.navigationService.selectedSection.next(section);

    setTimeout(() => {

      const element =
        document.getElementById(section);

      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }, 50);

  }
}
